export const popularDestinations = [
  {
    id: '1',
    name: 'Manuel Antonio',
    description: 'Playas paradisíacas y vida silvestre',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=400',
    price: 45000,
    duration: '3 horas',
    rating: 4.8,
    category: 'playa'
  },
  {
    id: '2',
    name: 'Volcán Arenal',
    description: 'Majestuoso volcán y aguas termales',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400',
    price: 65000,
    duration: '4 horas',
    rating: 4.9,
    category: 'volcán'
  },
  {
    id: '3',
    name: 'Monteverde',
    description: 'Bosque nuboso y canopy tours',
    image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400',
    price: 55000,
    duration: '5 horas',
    rating: 4.7,
    category: 'naturaleza'
  },
  {
    id: '4',
    name: 'Tamarindo',
    description: 'Surf y atardeceres espectaculares',
    image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400',
    price: 40000,
    duration: '2.5 horas',
    rating: 4.6,
    category: 'playa'
  },
  {
    id: '5',
    name: 'Tortuguero',
    description: 'Canales naturales y tortugas marinas',
    image: 'https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=400',
    price: 85000,
    duration: '8 horas',
    rating: 4.9,
    category: 'naturaleza'
  },
  {
    id: '6',
    name: 'Guanacaste',
    description: 'Playas vírgenes y cultura local',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400',
    price: 50000,
    duration: '4 horas',
    rating: 4.5,
    category: 'cultura'
  }
];

export const vehicleTypes = [
  {
    id: 'sedan',
    name: 'Sedán',
    capacity: '1-4 personas',
    price: 1.0,
    icon: '🚗',
    description: 'Cómodo para grupos pequeños'
  },
  {
    id: 'suv',
    name: 'SUV',
    capacity: '1-6 personas',
    price: 1.5,
    icon: '🚙',
    description: 'Ideal para familias'
  },
  {
    id: 'van',
    name: 'Van',
    capacity: '7-12 personas',
    price: 2.0,
    icon: '🚐',
    description: 'Perfecto para grupos grandes'
  },
  {
    id: 'bus',
    name: 'Autobús',
    capacity: '13+ personas',
    price: 2.5,
    icon: '🚌',
    description: 'Para excursiones grupales'
  }
];